import React from 'react'
import { ElementProps } from '../base/element'
import { ICommonProps, IDefaultStyles } from '../schemamanager/types'

export interface IIconComponent extends ICommonProps {
  type: 'icon'
  iconComp: any
}


export const Icon = (props: ElementProps) => {
  const comp = props.comp as IIconComponent
  
  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'mx-2 my-1',
        height: 'h-8',
        width: 'w-8',
        textColor: props.themeColor().textColor,
        fontWeight: 'font-bold'
      }
    }
  }
    
  const m = props.mergeStyles(style)


  return <comp.iconComp {...m.main} {...props.events()}/>
}
